export const environment = {
  production: true,
  API_BASE_URL: 'https://collection-center-api-uat.vercel.app/agro-api/collection-center-api/api',
};
